import React, { useState, useEffect } from "react";
import axios from "../../../axios";
import { formatDate } from "../../../utils/constants";
import * as url from "../../../utils/url";
import moment from "moment";
import badge1Img from "../../../assets/badge1.png";
import badge2025Img from "../../../assets/mmBadge2025.png";
import { BsDownload } from "react-icons/bs";

export default function LatestSummaryCardData() {
  const [score, setScore] = useState(null);
  const [loading, setLoading] = useState(false);
  const [benchmark, setBenchmark] = useState(null);

  const availableBadge =
    moment()
      .format("YYYY")
      .toString() === "2025"
      ? badge2025Img
      : badge1Img;

  useEffect(() => {
    setLoading(true);
    const d = formatDate(new Date());
    axios
      .get(url.getMMBenchmarksData)
      .then(({ data }) => {
        const benchmarksList = [...data.data];
        axios
          .post(url.getScoreByDate, {
            selectedDate: d ? formatDate(d) : null,
          })
          .then(({ data }) => {
            if (data.data.score) {
              setLoading(false);
              setScore(data.data.score.total_score);

              const bMark = benchmarksList.find(
                (x) => x._id == data.data.score.selectedBenchmarkId
              );
              setBenchmark(bMark);
            } else {
              axios
                .post(url.getScoreByDate, {
                  selectedDate: null,
                  showDataBeforeDate: formatDate(d),
                })
                .then(({ data }) => {
                  if (data.data.score) {
                    setLoading(false);

                    setScore(data.data.score.total_score);
                    const bMark = benchmarksList.find(
                      (x) => x._id == data.data.score.selectedBenchmarkId
                    );
                    setBenchmark(bMark);
                  } else {
                    setLoading(false);
                  }
                })
                .catch((err) => {
                  setLoading(false);
                  console.log(err);
                });
            }
          })
          .catch((err) => {
            setLoading(false);
            console.log(err);
          });
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, []);

  const handleDownload = async (option) => {
    console.log("Downloading Badge...");

    let img = availableBadge;
    let name = "Aware";

    if (score > 0 && score <= 25) {
      img = null;
      name = "";
    } else if (score >= 26 && score <= 50) {
      img = availableBadge;
      name = "Aware";
    } else if (score >= 51 && score <= 75) {
      img = availableBadge;
      name = "Focused";
    } else if (score >= 76 && score <= 100) {
      img = availableBadge;
      name = "Progressive";
    }

    const link = document.createElement("a");
    link.href = img;

    // link.download = `Badge ${name}.png`; // Set the file name for the download
    link.download = `Badge ${moment(new Date()).format(
      "dddd, MMMM Do YYYY"
    )}.png`; // Set the file name for the download

    // Append the link to the body temporarily, trigger click, and remove the link
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Logic to download badge
  };

  const getLabel = () => {
    if (score > 1 && score <= 26) {
      return "Aware";
    } else if (score >= 26 && score <= 51) {
      return "Focused";
    } else if (score >= 51 && score <= 76) {
      return "Progressive";
    } else if (score >= 76 && score <= 100) {
      return "World Class";
    }
  };

  if (loading) {
    return <div className="text-center">Loading...</div>;
  } else {
    return (
      <div>
        {score ? (
          <div className="enterpriseObjStatInt">
            {Math.round(score)}
            <span>%</span>
          </div>
        ) : (
          <div>No Score</div>
        )}

        <div style={{ fontSize: "1.3em", fontWeight: "300", marginTop: "35%" }}>
          {getLabel()}
        </div>

        {benchmark && (
          <div className="my-3" style={{ fontSize: "14px" }}>
            Benchmark:{benchmark.total_score}%
          </div>
        )}

        <div
          className="download_badge_section cursor-pointer"
          onClick={handleDownload}
        >
          <BsDownload className="mr-1" /> Download badge
        </div>
      </div>
    );
  }
}
